import React from 'react';
import { Checkbox as BulmaCheckbox } from 'react-bulma-components/lib/components/form';

import './style.scss';

export const Checkbox = ({ children, ...props }) => (
  <BulmaCheckbox {...props}>
    {' '}
    <span role="checkbox" aria-checked={props.checked}></span> {children}
  </BulmaCheckbox>
);

export default Checkbox;
